module.exports = __webpack_public_path__ + "media/images/icons/calendar-dark-blue-1bd641874d1313b082a5263538b3b595.svg";